import * as com from '../../Common'

const getAppUrl = () => {
    const hostname = window.location.hostname || ''
    let appUrl = com.returnURLs.appurl

    if (!appUrl) {
        if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname.endsWith('.net')) {
            appUrl = 'https://app.zeitro.net'
        } else if (hostname.endsWith('.com')) {
            appUrl = 'https://app.zeitro.com'
        } else {
            appUrl = 'https://app.zeitro.us'
        }
    }

    return appUrl
}

export const getZeitrotagSrc = (pageid) => {
    const customerId = com.getCustomerId() || ''
    const appUrl = getAppUrl()

    return `${appUrl}/api/zeitrotag.js?customerid=${customerId}&loid=&pageid=${pageid}`
}

export const buildSnippet = (pageid) =>
    `<script id="zeitrotag" src="${getZeitrotagSrc(pageid)}"></script>`
